import { CHART_OTHER, type RadialDatum } from "@outpave/ds";

/**
 * The entries largest first, capped at `max`: past the cap, the largest
 * `max - 1` stay and the rest are summed into one "Other" entry, so the chart
 * still adds up to the whole instead of silently dropping its tail.
 */
export const collapseToTop = (
  entries: RadialDatum[],
  max: number,
  otherLabel: (count: number) => string,
): RadialDatum[] => {
  const sorted = [...entries].sort((a, b) => b.value - a.value);
  if (sorted.length <= max) return sorted;

  const tail = sorted.slice(max - 1);
  return [
    ...sorted.slice(0, max - 1),
    {
      label: otherLabel(tail.length),
      value: tail.reduce((sum, entry) => sum + entry.value, 0),
      color: CHART_OTHER,
    },
  ];
};
